import { Logger } from 'src/common/services/Logger';

import { DELETE_URL_BY_PRODUCT } from './DeleteRunService.constants';
import { DeleteProduct, DeleteRunResponse } from './DeleteRunService.types';
import { apiCall } from './ServerApi';

export type { DeleteProduct } from './DeleteRunService.types';

export const deleteRunById = async (
	product: DeleteProduct,
	runId: string
): Promise<DeleteRunResponse> => {
	try {
		return await apiCall('POST', DELETE_URL_BY_PRODUCT[product], {
			data: {
				scope: {
					conditions: [{ field: 'run_id', value: runId }],
					entityName: 'all'
				}
			},
			isAbsoluteUrl: true
		});
	} catch (e) {
		Logger.error('deleteRunById failed', { product, runId, e });
		throw e;
	}
};
